import { create } from 'zustand';
import type { Point } from '../core/types';

/**
 * Pointer read-outs update on every mouse move. They live in their own store so
 * that the main store's subscribers — including the render loop — stay quiet.
 */
interface HudState {
  cursor: Point | null;
  setCursor: (cursor: Point | null) => void;
}

export const useHudStore = create<HudState>((set) => ({
  cursor: null,
  setCursor: (cursor) => set({ cursor }),
}));
